import RecentActivity from '@features/activity/components/RecentActivity';

export default function UpdatesJournal() {
  return (
    <div data-testid="updates-journal">
      <RecentActivity module="Updates" />
    </div>
  );
}
